import { useAuthentication } from "Context/AuthenticationContext";
import { Step5Response } from "Types/Cart";
import { invalidateCache, useStatePersist } from "use-state-persist";

// eslint-disable-next-line @typescript-eslint/ban-types
type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

const useTunnel = () => {
  const { token } = useAuthentication();
  const tunnelName = `${token}:tunnel`;
  const [tunnel, setTunnel] = useStatePersist<DeepPartial<Step5Response>>(tunnelName, {});

  const getTunnel = (): DeepPartial<Step5Response> => tunnel;
  const removeTunnel = () => invalidateCache(tunnelName);

  return {
    getTunnel,
    setTunnel,
    removeTunnel,
    tunnelName,
  };
};

export default useTunnel;
